import React, { Component } from 'react';

import { formatProjectLicensePrice } from '~/components/legacy/projectLicenseWizard.js';

class PricingLicenseCard extends Component {
  i18nValue(key) {
    if (this.props.i18n && this.props.i18n[key] !== undefined) {
      return this.props.i18n[key];
    }

    return PricingLicenseCard.defaultProps.i18n[key];
  }

  actionLabel() {
    if (this.props.isActive) {
      return this.i18nValue('continue_with_family');
    }

    if (this.props.hasActiveFamily) {
      return this.i18nValue('switch_to_family').replace('%{family}', this.props.family.title);
    }

    return this.props.family.pricing_card?.cta_label || this.i18nValue('configure_family').replace('%{family}', this.props.family.title);
  }

  startingPriceLabel() {
    return this.props.family.pricing_card?.starting_price_label || this.i18nValue('starting_price');
  }

  savedPresetCountLabel(count) {
    if (this.props.locale === 'de') {
      return count === 1 ? '1 gespeicherte Konfiguration' : `${count} gespeicherte Konfigurationen`;
    }

    return count === 1 ? '1 saved configuration' : `${count} saved configurations`;
  }

  renderSavedPresetSummary() {
    const savedPresets = Array.isArray(this.props.savedPresets) ? this.props.savedPresets : [];
    const justSavedPreset = this.props.justSavedPreset;
    const savedPresetCountLabel = this.savedPresetCountLabel(savedPresets.length);

    if (!justSavedPreset && savedPresets.length === 0) {
      return null;
    }

    return (
      <div className='pricing-license-card__selection-meta'>
        {justSavedPreset ? (
          <div className='pricing-license-card__selection-meta-row pricing-license-card__selection-meta-row--success'>
            <span className='pricing-license-card__selection-meta-label'>{this.i18nValue('just_saved')}</span>
            <strong>{justSavedPreset.name}</strong>
          </div>
        ) : null}
        {savedPresets.length > 0 ? (
          <div className='pricing-license-card__selection-meta-row'>
            <span className='pricing-license-card__selection-meta-label'>{this.i18nValue('saved_configurations')}</span>
            {this.props.managePresetsPath ? (
              <strong>
                <a href={this.props.managePresetsPath}>{savedPresetCountLabel}</a>
              </strong>
            ) : (
              <strong>{savedPresetCountLabel}</strong>
            )}
          </div>
        ) : null}
      </div>
    );
  }

  render() {
    const useCases = Array.isArray(this.props.family.pricing_card?.use_cases) ? this.props.family.pricing_card.use_cases.slice(0, 4) : [];
    const cardClassName = [
      'pricing-license-card',
      'pricing-license-card--selection',
      this.props.isActive ? 'pricing-license-card--selection-active' : '',
      this.props.hasActiveFamily && !this.props.isActive ? 'pricing-license-card--selection-dimmed' : ''
    ].filter(Boolean).join(' ');

    return (
      <section className={cardClassName} ref={this.props.cardRef}>
        <header className='pricing-license-card__selection-head'>
          <div>
            <h2 className='pricing-license-card__title pricing-license-card__title--selection'>{this.props.family.title}</h2>
            <p className='pricing-license-card__description pricing-license-card__description--selection'>{this.props.family.description}</p>
          </div>
          {this.props.isActive ? (
            <span className='pricing-license-card__status-badge'>{this.i18nValue('selected_badge')}</span>
          ) : null}
        </header>

        <div className='pricing-license-card__selection-price'>
          <span className='pricing-license-card__selection-price-label'>{this.startingPriceLabel()}</span>
          <strong>{formatProjectLicensePrice(this.props.family.gross_price_cents, this.props.locale)}</strong>
        </div>

        <p className='pricing-license-card__selection-hint'>{this.i18nValue('final_price_hint')}</p>

        {useCases.length > 0 ? (
          <div className='pricing-license-card__selection-use-cases'>
            <div className='pricing-license-card__section-label'>{this.i18nValue('typical_use_cases')}</div>
            <ul className='pricing-license-card__use-case-list'>
              {useCases.map((useCase) => (
                <li key={`${this.props.family.key}-${useCase}`}>{useCase}</li>
              ))}
            </ul>
          </div>
        ) : null}

        {this.renderSavedPresetSummary()}

        <div className='pricing-license-card__selection-actions'>
          <button type='button' className='button button--full' onClick={this.props.onSelect}>
            {this.actionLabel()}
          </button>
        </div>
      </section>
    );
  }
}

PricingLicenseCard.defaultProps = {
  locale: 'de',
  savedPresets: [],
  justSavedPreset: null,
  managePresetsPath: null,
  isActive: false,
  hasActiveFamily: false,
  onSelect: () => {},
  cardRef: null,
  i18n: {
    selected_badge: 'Ausgewählt',
    starting_price: 'Startpreis ab',
    final_price_hint: 'Den finalen Projektpreis konfigurieren Sie im nächsten Schritt.',
    typical_use_cases: 'Typische Nutzungsszenarien',
    configure_family: 'Preis für %{family}-Lizenz konfigurieren',
    switch_to_family: 'Stattdessen %{family} wählen',
    continue_with_family: 'Konfiguration fortsetzen',
    just_saved: 'Gerade gespeichert',
    saved_configurations: 'Gespeicherte Konfigurationen'
  }
};

export default PricingLicenseCard;
